import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { AppType, ConfigurationService } from '@treasury/core/config';
import { ProductFeatureType } from '@treasury/domain/company/product-features/types';
import { CompanyUserService } from '@treasury/domain/company/user';
import { CompanyUserProductEntitlements } from '@treasury/domain/company/user/entities/entitlements';
import { CompanyUserProductLimits } from '@treasury/domain/company/user/entities/limits';
import { TmWizardStep } from '@treasury/presentation/components/tm-wizard';
import { TmToastPosture, TmToastService } from '@treasury/presentation/services/toast';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('tm-bo-positive-pay-check-exception-permissions')
export class PositivePayCheckExceptionsPermissions extends TmWizardStep {
    public stepLabel = 'Check Exceptions';

    @property({ type: Number })
    public companyId?: number;

    @property({ type: Number })
    public userId?: number;

    @InjectProperty()
    declare private readonly config: ConfigurationService;

    @InjectProperty()
    declare private readonly companyUserService: CompanyUserService;

    @InjectProperty()
    declare private readonly toastService: TmToastService;

    @state()
    private entitlements?: CompanyUserProductEntitlements;

    @state()
    private limits?: CompanyUserProductLimits;

    @state()
    private loading = true;

    private get isBoApp() {
        return this.config.app === AppType.BackOffice;
    }

    public render() {
        if (this.loading) {
            return html`<jha-progress></jha-progress> Loading Positive Pay Check Exception
                Permissions...`;
        }
        return html`${this.renderLimitsAndEntitlements()}`;
    }

    public validate() {
        return true;
    }

    protected async firstUpdated() {
        try {
            if (this.isBoApp && !this.companyId) {
                throw new Error('Company ID is required');
            }
            if (!this.userId) {
                throw new Error('User ID is required');
            }

            this.loading = true;

            this.entitlements =
                await this.companyUserService.getCompanyUserProductEntitlementsByType(
                    this.userId,
                    ProductFeatureType.Arp,
                    this.companyId
                );
        } catch {
            this.toastService.show(
                'Error fetching positive pay check exceptions permissions',
                TmToastPosture.Danger,
                true
            );
        } finally {
            this.loading = false;
        }
    }

    private renderLimitsAndEntitlements() {
        if (!this.entitlements) {
            return nothing;
        }

        return html`<tm-company-user-limits-and-entitlements-common
            .companyId=${this.companyId}
            .userId=${this.userId}
            .limits=${this.limits}
            .entitlements=${this.entitlements}
        ></tm-company-user-limits-and-entitlements-common>`;
    }
}
